
const determineTransactionRequest = (pin, utility, token, singleInvoice, utilitySliceState, transID, amount, checked, isEsimRegistered ) => 
{
    switch(utility)
    {
        case 'OSHEE':
            return (
                {
                    startTransaction: {
                        token: token,
                        serie: singleInvoice['Seriali i Fatures'],
                        type: utilitySliceState.extraInvoiceListData.type
                    },
                    confirmTransaction: 
                    {
                        token: token,
                        transID: utilitySliceState.transactionId,
                        service: utility,
                        passkey: pin,
                        passkeyType: 1,
                        comeFromWeb: true
                    },
                    endpoints: 
                    {
                        start: 'OSHEE/StartTransaction',
                        confirm:'OSHEE/ConfirmTransaction'
                    }
                }
            )
            case 'GJOBAT':
                return (
                    {
                        startTransaction: {
                            token: token,
                            serie: singleInvoice['Seriali']
                        },
                        confirmTransaction: 
                        {
                            token: token,
                            transID: utilitySliceState.transactionId,
                            service: utility,
                            passkey: pin,
                            passkeyType: 1,
                            comeFromWeb: true
                        },
                        endpoints: 
                        {
                            start: 'Penalty/StartTransaction',
                            confirm:'Penalty/ConfirmTransaction'
                        }
                    }
                )
            case 'QEZHEF':
                return (
                    {
                        startTransaction: {
                            token: token,
                            serie: singleInvoice['Seriali']
                        },
                        confirmTransaction: 
                        {
                            token: token,
                            transID: utilitySliceState.transactionId,
                            service: utility,
                            passkey: pin,
                            passkeyType: 1,
                            comeFromWeb: true
                        },
                        endpoints: 
                        {
                            start: 'QEZHEF/StartTransaction',
                            confirm:'QEZHEF/ConfirmTransaction'
                        }
                    }
                )
                case 'DIGICOM':
                    return (
                        {
                            startTransaction: {
                                token: token,
                                serie: singleInvoice['Serial'],
                            },
                            confirmTransaction: 
                            {
                                token: token,
                                transID: utilitySliceState.transactionId,
                                service: utility,
                                passkey: pin,
                                passkeyType: 1,
                                comeFromWeb: true
                            },
                            endpoints: 
                            {
                                start: 'DIGICOM/StartTransaction',
                                confirm:'DIGICOM/ConfirmTransaction'
                            }
                        }
                    )
                    case 'FirstCom':
                    return (
                        {
                            startTransaction: {
                                token: token,
                                id: singleInvoice['Numri i kontrates'],
                            },
                            confirmTransaction: 
                            {
                                token: token,
                                transID: utilitySliceState.transactionId
                            },
                            endpoints: 
                            {
                                start: 'Firstcom/StartTransactionFirstcom',
                                confirm:'Fistcom/ConfirmTransactionFistCom'
                            }
                        }
                    )
                case 'ABISSNET':
                return (
                    {
                        confirmTransaction: 
                        {
                            token: token,
                            transID: utilitySliceState.transactionId,
                            passkey: pin,
                            passkeyType: 1,
                            comeFromWeb: true
                        },
                        endpoints: 
                        {
                            confirm:'Abissnet/ConfirmTransactionAbissnet'
                        }
                    }
                )
                case 'ALBTELECOM':
                    return (
                        {
                            startTransaction: {
                                token: token,
                                serie: singleInvoice['Serial'],
                            },
                            confirmTransaction: 
                            {
                                token: token,
                                transID: utilitySliceState.transactionId,
                                service: utility,
                                passkey: pin,
                                passkeyType: 1,
                                comeFromWeb: true
                            },
                            endpoints: 
                            {
                                start: 'ALBTELECOM/StartTransactionAlbtelecom',
                                confirm:'ALBTELECOM/ConfirmTransactionAlbtelecom'
                            }
                        }
                    )
                case 'TAKSAT_DURRES':
                    debugger
                return (
                    {
                        confirmTransaction: 
                        {
                            token: token,
                            transID: utilitySliceState.transactionId,
                            passkey: pin,
                            passkeyType: 1,
                            comeFromWeb: true
                        },
                        endpoints: 
                        {
                            confirm:'TAKSAVENDORE/ConfirmTransactionTaxes'
                        }
                    }
                )
                case 'TAKSAT_SHKODER':
                return (
                    {
                        confirmTransaction: 
                        {
                            token: token,
                            transID: utilitySliceState.transactionId,
                            passkey: pin,
                            passkeyType: 1,
                            comeFromWeb: true

                        },
                        endpoints: 
                        {
                            confirm:'TAKSAVENDORE/ConfirmTransactionTaxes'
                        }
                    }
                )
                case 'Siguracione':
                return (
                    {
                        confirmTransaction: 
                        {
                            token: token,
                            transID: utilitySliceState.transactionId,
                            service: utilitySliceState.extraData.service,
                            passkey: pin,
                            passkeyType: 1,
                            comeFromWeb: true
                        },
                        endpoints: 
                        {
                            confirm:'ConfirmTransactionSHU'
                        }
                    }
                )
                case utility.startsWith('UK') ? utility : '' :
                    return (
                        {
                            startTransaction: {
                                token: token,
                                serie: singleInvoice['Seria'],
                                service: utility,
                                contractNo: utilitySliceState.extraInvoiceListData.contractNumber
                            },
                            confirmTransaction: 
                            {
                                token: token,
                                transID: utilitySliceState.transactionId,
                                service: utility,
                                passkey: pin,
                                passkeyType: 1,
                                comeFromWeb: true
                            },
                            endpoints: 
                            {
                                start: 'UK/StartTransactionUK',
                                confirm:'UK/ConfirmTransactionUK'
                            }
                        }
                    )
                    case 'KREDO':
                        return (
                            {
                                confirmTransaction: 
                                {
                                    token: token,
                                    transID: transID,
                                    passkey: pin,
                                    passkeyType: 1,
                                    comeFromWeb: true
                                },
                                endpoints: 
                                {
                                    confirm:'Kredo/ConfirmTransactionKredo'
                                }
                            }
                        )
                        case 'NOA':
                            return (
                                {
                                    confirmTransaction: 
                                    {
                                        token: token,
                                        transID: transID,
                                        passkey: pin,
                                        passkeyType: 1,
                                        comeFromWeb: true
                                    },
                                    endpoints: 
                                    {
                                        confirm:'NOA/ConfirmTransactionNoa'
                                    }
                                }
                            )
                    case 'FshatiSOS': 
                        return (
                            {
                                startTransaction: {
                                    token: token,
                                    value: amount,
                                    anonymous: checked
                                },
                                confirmTransaction: 
                                {
                                    token: token,
                                    transID: utilitySliceState.transactionId,
                                    passkey: pin,
                                    passkeyType: 1,
                                    comeFromWeb: true
                                },
                                endpoints: 
                                {
                                    start: 'FshatiSOS/StartTransactionFshatiSos',
                                    confirm:'FshatiSOS/ConfirmTransactionFshatiSos'
                                }
                            }
                    )
                    case 'SIGURIIME_MOTORRIKE': 
                        return (
                            {
                                confirmTransaction: 
                                {
                                    token: token,
                                    transID: transID,
                                    passkey: pin,
                                    passkeyType: 1,
                                    comeFromWeb: true
                                },
                                endpoints: 
                                {
                                    confirm:'SigurimeMotorrike/Confirm'
                                }
                            }
                        )
                        case 'ESIM_99':
                            return (
                                {
                                    confirmTransaction: 
                                    {
                                        token: token,
                                        trxId: transID,
                                        // passkey: pin,
                                        // passkeyType: 1,
                                        // comeFromWeb: true
                                    },
                                    endpoints: 
                                    {
                                        confirm:`Esim99/${isEsimRegistered ? 'ConfirmRefill99Esim' : 'ConfirmRegister99Esim'}`
                                    }
                                }
                            )
    }
}
export {determineTransactionRequest as determineTransactionRequest}